import './addFriendPage.css';
import React, {Component} from "react";
import {Navigate} from "react-router-dom";
import FriendService from "../services/friendService";
import {ToastErrorLevel} from "../../App";
import {withRouter} from "./withRouter";
import LoadingSpinner from "./loadingSpinner";
import i18nService from "../../i18n/i18nService";

interface AddFriendState {
    navigation?: string,
    isLoading: boolean,
    error?: string,
    success: boolean,
}

interface AddFriendProps {
    toastGenerator: (body: string, level: ToastErrorLevel) => any,
    onLogout: any,
}

class AddFriendPage extends Component<AddFriendProps, AddFriendState> {
    constructor(props: AddFriendProps) {
        super(props);
        this.state = {
            isLoading: false,
            success: false,
        };
        this.handleAddFriend = this.handleAddFriend.bind(this);
        this.handleRedirection = this.handleRedirection.bind(this);
    }

    async componentDidMount() {
        // @ts-ignore
        const username = this.props.params?.username;
        if (username) {
            await this.handleAddFriend(decodeURIComponent(username));
        } else {
            this.setState({
                navigation: '/dashboard',
            });
        }
    }

    async handleRedirection(redirectionUrl: string) {
        if (redirectionUrl.startsWith("/login")) {
            this.props.onLogout();
        }
        this.setState({
            navigation: redirectionUrl
        });
    }

    async handleAddFriend(username: string) {
        this.setState({isLoading: true, error: undefined});
        await FriendService.addFriend({
            username: username.trim(),
        }, async () => {
            this.props.toastGenerator(`Successfully added ${username} as a friend!`, ToastErrorLevel.INFO);
            this.setState({success: true, isLoading: false});
            setTimeout(() => {
                this.setState({navigation: '/profile'});
            }, 2000);
        }, async (error: string) => {
            this.setState({error, isLoading: false});
            this.props.toastGenerator(error, ToastErrorLevel.ERROR);
        }, this.handleRedirection);
    }

    render() {
        if (this.state.navigation) {
            return <Navigate to={this.state.navigation}/>;
        }

        return (
            <div className="AddFriendPage-Wrapper">
                <div className="AddFriendPage-Container">
                    {this.state.isLoading && (
                        <div className="AddFriendPage-Loading">
                            <LoadingSpinner size="large" message={i18nService.t('friends.addingFriend', 'Adding friend...')} />
                        </div>
                    )}
                    {this.state.success && (
                        <div className="AddFriendPage-Success">
                            <h2>{i18nService.t('friends.friendAddedSuccess', 'Friend Added Successfully!')}</h2>
                            <p>{i18nService.t('friends.redirectingToProfile', 'Redirecting to your profile...')}</p>
                        </div>
                    )}
                    {this.state.error && !this.state.isLoading && (
                        <div className="AddFriendPage-Error">
                            <h2>{i18nService.t('friends.failedToAddFriend', 'Failed to Add Friend')}</h2>
                            <p>{this.state.error}</p>
                            <button 
                                className="AddFriendPage-Button"
                                onClick={() => this.setState({navigation: '/profile'})}
                            >
                                {i18nService.t('friends.goToProfile', 'Go to Profile')}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(AddFriendPage);

